// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"618862b4","393":"d3e9f5cb","447":"778149ec","846":"a17de532","967":"8b76c718"}[chunkId] + ".chunk.js";
};